module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Feedback","submit":"Senden","close":"Abbrechen","label":"Feedback","error":"Bitte geben Sie Ihr Feedback ein"},"en":{"title":"Feedback","submit":"Submit","close":"Cancel","label":"Feedback","error":"Please enter your feedback"}}')
  delete Component.options._Ctor
}
